"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetCommunityRankingDataResponseToJSON = exports.GetCommunityRankingDataResponseFromJSONTyped = exports.GetCommunityRankingDataResponseFromJSON = void 0;
var _1 = require("./");
function GetCommunityRankingDataResponseFromJSON(json) {
    return GetCommunityRankingDataResponseFromJSONTyped(json, false);
}
exports.GetCommunityRankingDataResponseFromJSON = GetCommunityRankingDataResponseFromJSON;
function GetCommunityRankingDataResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'communityRankingRecords': (json['communityRankingRecords'].map(_1.CommunityRankingRecordFromJSON)),
    };
}
exports.GetCommunityRankingDataResponseFromJSONTyped = GetCommunityRankingDataResponseFromJSONTyped;
function GetCommunityRankingDataResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'communityRankingRecords': (value.communityRankingRecords.map(_1.CommunityRankingRecordToJSON)),
    };
}
exports.GetCommunityRankingDataResponseToJSON = GetCommunityRankingDataResponseToJSON;
